// Remove direct Firestore imports
// import { 
//     collection, 
//     addDoc, 
//     getDocs, 
//     query, 
//     where, 
//     deleteDoc, 
//     doc, 
//     getDoc,
//     setDoc
// } from 'firebase/firestore';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// Add a location to user favorites via API
export const addToFavorites = async (token, cityName, locationId, locationName) => {
    if (!token) return { success: false, message: "Authentication token is required." };
    try {
        const response = await fetch(`${API_BASE_URL}/favorites`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ cityName, locationId, locationName })
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.error || 'Failed to add favorite via API');
        }
        return { success: true, message: data.message, id: data.id }; 
    } catch (error) {
        console.error('Error adding to favorites via API:', error);
        return { success: false, message: error.message };
    }
};

// Remove a location from user favorites via API
export const removeFromFavorites = async (token, cityName, locationId) => {
    if (!token) return { success: false, message: "Authentication token is required." };
    try {
        const response = await fetch(`${API_BASE_URL}/favorites/${encodeURIComponent(cityName)}/${encodeURIComponent(locationId)}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.error || 'Failed to remove favorite via API');
        }
        return { success: true, message: data.message };
    } catch (error) {
        console.error('Error removing from favorites via API:', error);
        return { success: false, message: error.message };
    }
};

// Check if a location is in user favorites via API
export const checkIfFavorite = async (token, cityName, locationId) => {
    if (!token) {
        console.warn('No token provided for checkIfFavorite, returning false.');
        return false;
    }
    try {
        const response = await fetch(`${API_BASE_URL}/favorites/${encodeURIComponent(cityName)}/${encodeURIComponent(locationId)}/check`, {
             headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        const data = await response.json();
        if (!response.ok) {
            console.error('API error checking favorite status:', data.error || response.statusText);
            return false; 
        }
        return data.isFavorite; 
    } catch (error) {
        console.error('Error checking favorite status via API:', error);
        return false; 
    }
};

// Get all favorites for the current user via API
export const getUserFavorites = async (token) => {
    if (!token) return [];
    try {
        const response = await fetch(`${API_BASE_URL}/favorites`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
             const errorData = await response.json();
             throw new Error(errorData.error || 'Failed to fetch favorites via API');
        }
        
        const favorites = await response.json();
        return favorites;
    } catch (error) {
        console.error('Error getting user favorites via API:', error);
        return [];
    }
}; 